export default function StatusBadge({ status }) {
  const styles = {
    // ===== EXPERIENCE STATUSES =====
    Draft: {
      bg: "bg-disabledGray",
      text: "text-white",
    },
    Pending: {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    Approved: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Rejected: {
      bg: "bg-errorRed",
      text: "text-white",
    },
    Active: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Resolved: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Ongoing: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },
    Upcoming: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },
    Completed: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Cancelled: {
      bg: "bg-errorRed",
      text: "text-white",
    },

    // ===== BOOKING / CONFIRMATION =====
    "Pending Vendor Confirmation": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    Confirmed: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    "In Review": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },

    // ===== PAYMENT STATUSES =====
    PAID: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Paid: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Processing: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },
    PendingPayment: {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    Failed: {
      bg: "bg-errorRed",
      text: "text-white",
    },
    Succeeded: {
      bg: "bg-successGreen",
      text: "text-white",
    },

    // ===== REFUND STATUSES =====
    "Refund Initiated": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    "Refund Pending": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    Refunded: {
      bg: "bg-disabledGray",
      text: "text-white",
    },
    "Refund Failed": {
      bg: "bg-errorRed",
      text: "text-white",
    },

    // ===== PAYOUT STATUSES =====
    PayoutPending: {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    PayoutProcessing: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },
    PayoutCompleted: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    PaidOut: {
      bg: "bg-successGreen",
      text: "text-white",
    },
    PayoutFailed: {
      bg: "bg-errorRed",
      text: "text-white",
    },
    "On Hold": {
      bg: "bg-disabledGray",
      text: "text-white",
    },
    "Pending Vendor Confirmation": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    "Pending User Confirmation": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    "Awaiting User Confirmation": {
      bg: "bg-pendingAmber",
      text: "text-white",
    },
    Pending: {
      bg: "bg-pendingAmber",
      text: "text-white",
    },

    // ===== ALTERNATE TIME =====
    "Vendor Proposed Alternate Time": {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },

    // ===== UPCOMING / ONGOING =====
    Upcoming: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },
    Ongoing: {
      bg: "bg-upcomingBlue",
      text: "text-white",
    },

    // ===== COMPLETION =====
    "Vendor Completed": {
      bg: "bg-successGreen",
      text: "text-white",
    },
    Completed: {
      bg: "bg-successGreen",
      text: "text-white",
    },

    // ===== DENIED / CANCELLED =====
    "Denied By Vendor": {
      bg: "bg-errorRed",
      text: "text-white",
    },
    "Denied By User": {
      bg: "bg-errorRed",
      text: "text-white",
    },
    Cancelled: {
      bg: "bg-errorRed",
      text: "text-white",
    },
    "Canceled By User": {
      bg: "bg-errorRed",
      text: "text-white",
    },

    // ===== NO SHOW =====
    "No Show": {
      bg: "bg-disabledGray",
      text: "text-white",
    },
  };

  const { bg, text } = styles[status] || {
    bg: "bg-gray-300",
    text: "text-black",
  };

  return (
    <span
      className={`
          ${bg} ${text}
          inline-flex
          justify-center items-center
          px-6 py-3
          rounded-lg
          text-[14px]
          font-medium
          leading-none
          font-outfit
          min-w-[150px]
          text-center
          shadow-[0px_1px_2px_rgba(0,0,0,0.1)]
        `}
    >
      {status}
    </span>
  );
}
